import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/utils/apiClient";
import { useAuth } from "@/state/auth";
import type { Citation, Locale, TokenUsage } from "@/types/content";

export interface ContentTestRunPayload {
  template_id: number;
  inputs: Record<string, unknown>;
  include_audio?: boolean;
}

export interface ContentTestRunResult {
  text: string;
  audio_url?: string | null;
  citations: Citation[];
  log_id: number;
  latency_ms: number;
  tokens: TokenUsage;
  template_slug?: string;
  locale?: Locale;
}

const runTestGeneration = async (
  payload: ContentTestRunPayload
): Promise<ContentTestRunResult> => {
  return apiRequest<ContentTestRunResult>("/api/admin/content-test-run", {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const useContentTestRun = () => {
  const profile = useAuth((state) => state.profile);
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: ContentTestRunPayload) => runTestGeneration(payload),
    onSuccess: () => {
      if (!profile) return;
      queryClient.invalidateQueries({ queryKey: ["generation-logs", "list"] });
    },
  });
};
